// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scniorBadage {\n  font-size: 0.6rem;\n}", ""]);
// Exports
module.exports = exports;
